import { useState } from "react";
import { supabase } from "../../lib/supabase";

interface UseSignInOptions {
  onSuccess: () => void;
}

interface UseSignInResult {
  email: string;
  setEmail: (v: string) => void;
  password: string;
  setPassword: (v: string) => void;
  error: string | null;
  loading: boolean;
  handleSubmit: (e: React.FormEvent) => Promise<void>;
}

/** Sign-in logic for the sign-in page. No role check — guards handle access at the route level. */
export function useSignIn({ onSuccess }: UseSignInOptions): UseSignInResult {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const { error: authError } = await supabase.auth.signInWithPassword({
        email: email.trim(),
        password,
      });
      if (authError) {
        setError(authError.message);
        return;
      }
      onSuccess();
    } finally {
      setLoading(false);
    }
  }

  return { email, setEmail, password, setPassword, error, loading, handleSubmit };
}
